






















import DOMPurify from "dompurify";
import { MemoApi, MemoDto } from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      data: {}
    };
  },
  name: "Memos",
  mixins: [stateMixin],
  components: {},
  mounted() {
    this.fetch();
  },
  methods: {
    fetch: async function() {
      this.setState(this.states.LOADING);
      try {
        const api = new MemoApi();
        const { data } = await api.memoGetActiveMemos();
        this.data = this.sanitizeData(data);
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    sanitizeData: function(data: MemoDto[]): MemoDto[] {
      data.forEach(item => {
        if (!item.text) return;
        item.text = DOMPurify.sanitize(item.text, {
          USE_PROFILES: { html: true }
        });
      });
      return data;
    }
  }
};
